import React, { useState, useEffect } from 'react';
import { Row, Col, FormGroup, FormControl, FormLabel, Form, Button, Modal, Alert } from 'react-bootstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import axios from 'axios';
import cuteMonk1 from '../../assets/img/baolinPrivate/cute_monk1.png';
import cuteMonk2 from '../../assets/img/baolinPrivate/cute_monk2.png';

function Edit3R5PModal({ editGuestModal, setEditGuestModal, registrationData }) {

    const MySwal = withReactContent(Swal);
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [chinesename, setChinesename] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [refuge_id, setRefuge_id] = useState('');
    const [precepts_id, setPrecepts_id] = useState('');
    
    const [language, setLanguage] = useState("English"); // Assuming default language is English

    const [firstnameError, setFirstnameError] = useState(null);
    const [lastnameError, setLastnameError] = useState(null);
    const [emailError, setEmailError] = useState(null);
    const [phoneError, setPhoneError] = useState(null);


    const [firstnameModifyChecked, setFirstnameModifyChecked] = useState(false);
    const [lastnameModifyChecked, setLastnameModifyChecked] = useState(false);
    const [chinesenameModifyChecked, setChinesenameModifyChecked] = useState(false);
    const [phoneModifyChecked, setPhoneModifyChecked] = useState(false);
    const [emailModifyChecked, setEmailModifyChecked] = useState(false);
    const [refuges_idChecked, setRefuges_idChecked] = useState('');
    const [precepts_idChecked, setPrecepts_idChecked] = useState('');

    const handleRefugesIdModify = (event) => {
        const isChecked = event.target.checked;
        setRefuges_idChecked(isChecked);
        // When unchecked, reset the firstname to the original value from registrationData
        if (!isChecked && registrationData) {
            setRefuge_id(registrationData.refuge_id);
        }
    };
    const handlePreceptsIdModify = (event) => {
        const isChecked = event.target.checked;
        setPrecepts_idChecked(isChecked);
        // When unchecked, reset the firstname to the original value from registrationData
        if (!isChecked && registrationData) {
            setPrecepts_id(registrationData.precepts_id);
        }
    };

    const handleFirstnameModifyChange = (event) => {
        const isChecked = event.target.checked;
        setFirstnameModifyChecked(isChecked);
        // When unchecked, reset the firstname to the original value from registrationData
        if (!isChecked && registrationData) {
            setFirstname(registrationData.firstname);
        }
    };
    const handleLastnameModifyChange = (event) => {
        const isChecked = event.target.checked;
        setLastnameModifyChecked(isChecked);
        // When unchecked, reset the firstname to the original value from registrationData
        if (!isChecked && registrationData) {
            setLastname(registrationData.lastname);
        }
    };

    const handleChinesenameModifyChange = (event) => {
        const isChecked = event.target.checked;
        setChinesenameModifyChecked(isChecked);
        if (!isChecked && registrationData) {
            setChinesename(registrationData.chinesename);
        }
    };

    const handlePhoneModifyChange = (event) => {
        const isChecked = event.target.checked;
        setPhoneModifyChecked(isChecked);
        if (!isChecked && registrationData) {
            setPhone(registrationData.phone);
        }
    };

    const handleEmailModifyChange = (event) => {
        const isChecked = event.target.checked;
        setEmailModifyChecked(isChecked);
        if (!isChecked && registrationData) {
            setEmail(registrationData.email);
        }
    };

    useEffect(() => {
        if (registrationData !== null) {
            setRefuge_id(registrationData.refuge_id);
            setPrecepts_id(registrationData.precepts_id);
            setFirstname(registrationData.firstname);
            setLastname(registrationData.lastname);
            setChinesename(registrationData.chinesename);
            setPhone(registrationData.phone);
            setEmail(registrationData.email);
        }
    }, [registrationData]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (true) {
            // Determine which fields have been changed
            const changes = [
                refuges_idChecked && { field: 'Refuge ID', before: registrationData.refuge_id, after: refuge_id },
                precepts_idChecked && { field: 'Precept ID', before: registrationData.precepts_id, after: precepts_id },
                lastnameModifyChecked && { field: 'Last Name', before: registrationData.lastname, after: lastname },
                firstnameModifyChecked && { field: 'First Name', before: registrationData.firstname, after: firstname },
                lastnameModifyChecked && { field: 'Last Name', before: registrationData.lastname, after: lastname },
                chinesenameModifyChecked && { field: 'Chinese Name', before: registrationData.chinesename, after: chinesename },
                emailModifyChecked && { field: 'Email', before: registrationData.email, after: email },
                phoneModifyChecked && { field: 'Phone', before: registrationData.phone, after: phone },
                // ... Repeat for other fields
            ].filter(Boolean); // Filter out unchecked fields

            // Prepare table content for SweetAlert
            const tableContent = `
            <style>
                .swal-table {
                    width: 100%;
                    margin-left: auto;
                    margin-right: auto;
                    border-collapse: collapse;
                }
                .swal-table th, .swal-table td {
                    padding: 8px; /* Adjust padding as needed */
                    text-align: left; /* Default alignment */
                }
                .swal-table th:nth-child(1), .swal-table td:nth-child(1) { /* Information column */
                    text-align: left;
                }
                .swal-table th:nth-child(3), .swal-table td:nth-child(3) { /* After column */
                    text-align: right;
                }
                .swal-table tbody tr:nth-child(odd) {
                    background-color: #f2f2f2; /* Light gray for striped effect */
                }
            </style>
            <table class="swal-table">
                <thead>
                    <tr><th>Information</th><th>Before</th><th>After</th></tr>
                </thead>
                <tbody>
                    ${changes.map(change => `<tr><td>${change.field}</td><td>${change.before}</td><td>${change.after}</td></tr>`).join('')}
                </tbody>
            </table>
            `;

            // Show SweetAlert2 Confirmation
            const result = await MySwal.fire({
                title: 'Please Confirm Changes',
                html: tableContent,
                showCancelButton: true,
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
            });

            if (result.isConfirmed) {
                // Prepare thepayload for API call
                const updatedData = {
                    registration_id: registrationData.registration_id,
                    ...(refuges_idChecked && { refuge_id }),
                    ...(precepts_idChecked && { precepts_id }),
                    ...(firstnameModifyChecked && { firstname }),
                    ...(lastnameModifyChecked && { lastname }),
                    ...(chinesenameModifyChecked && { chinesename }),
                    ...(emailModifyChecked && { email }),
                    ...(phoneModifyChecked && { phone }),
                };
                try {
                    // Send the API request
                    const response = await axios.put(`${process.env.REACT_APP_SERVER_URL}/event/3r5p/updateguest `, updatedData);
                    console.log(response.data);
                    if (response.status === 200) {
                        // Display a success message
                        await Swal.fire({
                            title: 'Success!',
                            text: 'The update was successful.',
                            icon: 'success',
                            confirmButtonText: 'OK'
                        });
                    }
                    // Handle response, like closing the modal or refreshing the data
                    setEditGuestModal(false);
                    // Refresh the page
                    window.location.reload();
                } catch (error) {
                    console.error('Error updating registration:', error);
                    // Check if the error response is available and has a specific reason
                    let errorMessage = 'An unknown error occurred. Please try again later.';
                    console.log(error.response.data.detail["reason"])
                    if (error.response && error.response.data && error.response.data.detail && error.response.data.detail.reason === "Duplicate entry") {
                        errorMessage = 'Duplicated with other guest!';
                    }
                    // Display an error alert
                    await Swal.fire({
                        title: 'Error!',
                        text: errorMessage,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
            }

        }
    }

    return (
        <>
            <Modal
                className=" modal-primary"
                onHide={() => {
                    setEditGuestModal(!editGuestModal);
                }}
                show={editGuestModal}
                size="lg">
                <Modal.Body >
                    <div>
                        <Form onSubmit={handleSubmit}>
                            <p className="text-center mb-2 font-weight-bold">
                                <img src={cuteMonk1} alt="Company Logo" width="40" className="mr-3" />
                                {language === "English" ? "View Guest Information" : "報名信息"}
                                <img src={cuteMonk2} alt="Company Logo" width="40" className="ml-3" />
                            </p>
{/* 
                            <Row>
                                <Col md={{ span: 10, offset: 1 }}>
                                    <hr />
                                    <p>The guest was registred at <span className='font-weight-bold text-primary'>{registrationTime}</span></p>
                                    <hr />
                                </Col>

                            </Row> */}
                            {/* <LanguageToggle setLanguage={setLanguage} /> */}
                            <Row>
                                <Col md={{ span: 10, offset: 1 }}>
                                    <FormGroup>
                                        <FormLabel>三皈編號<span className="text-danger">*</span></FormLabel>
                                        <div className="d-flex align-items-center">
                                            <FormControl
                                                type="text"
                                                name="refuge_id"
                                                maxLength="30"
                                                placeholder="ex: Mike"
                                                value={refuge_id}
                                                onChange={(event) => setRefuge_id(event.target.value)}
                                                disabled={!refuges_idChecked} // Disable input field based on checkbox state
                                            />
                                            <Form.Check>
                                                <Form.Check.Label>
                                                    <Form.Check.Input
                                                        label="refugeidModify"
                                                        type="checkbox"
                                                        checked={refuges_idChecked}
                                                        onChange={handleRefugesIdModify}
                                                    ></Form.Check.Input>
                                                    <span className="form-check-sign"></span>
                                                    Modify
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 10, offset: 1 }}>
                                    <FormGroup>
                                        <FormLabel>五戒編號<span className="text-danger">*</span></FormLabel>
                                        <div className="d-flex align-items-center">
                                            <FormControl
                                                type="text"
                                                name="precepts_id"
                                                maxLength="30"
                                                placeholder="ex: Mike"
                                                value={precepts_id}
                                                onChange={(event) => setPrecepts_id(event.target.value)}
                                                disabled={!precepts_idChecked} // Disable input field based on checkbox state
                                            />
                                            <Form.Check>
                                                <Form.Check.Label>
                                                    <Form.Check.Input
                                                        label="refugeidModify"
                                                        type="checkbox"
                                                        checked={precepts_idChecked}
                                                        onChange={handlePreceptsIdModify}
                                                    ></Form.Check.Input>
                                                    <span className="form-check-sign"></span>
                                                    Modify
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 10, offset: 1 }}>
                                    <FormGroup>
                                        <FormLabel>{language === "English" ? "First Name" : "英 文 名"}<span className="text-danger">*</span></FormLabel>
                                        <div className="d-flex align-items-center">
                                            <FormControl
                                                type="text"
                                                name="firstname"
                                                maxLength="30"
                                                placeholder="ex: Mike"
                                                value={firstname}
                                                onChange={(event) => setFirstname(event.target.value)}
                                                disabled={!firstnameModifyChecked} // Disable input field based on checkbox state
                                            />
                                            <Form.Check>
                                                <Form.Check.Label>
                                                    <Form.Check.Input
                                                        label="FirstnameModify"
                                                        type="checkbox"
                                                        checked={firstnameModifyChecked}
                                                        onChange={handleFirstnameModifyChange}
                                                    ></Form.Check.Input>
                                                    <span className="form-check-sign"></span>
                                                    Modify
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </div>
                                        {firstnameError && <small className="text-danger">{firstnameError}</small>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>

                                <Col md={{ span: 10, offset: 1 }}>
                                    <FormGroup>
                                        <FormLabel>{language === "English" ? "Last Name " : "英 文 姓"}<span className="text-danger">*</span></FormLabel>
                                        <div className="d-flex align-items-center">
                                            <FormControl type="text" name="lastname" maxLength="30" placeholder="ex: Andrew"
                                                value={lastname} onChange={(event) => setLastname(event.target.value)} disabled={!lastnameModifyChecked} />
                                            <Form.Check>
                                                <Form.Check.Label>
                                                    <Form.Check.Input
                                                        label="LastnameModify"
                                                        type="checkbox"
                                                        checked={lastnameModifyChecked}
                                                        onChange={handleLastnameModifyChange}
                                                    ></Form.Check.Input>
                                                    <span className="form-check-sign"></span>
                                                    Modify
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </div>
                                        {lastnameError && <small className="text-danger">{lastnameError}</small>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 10, offset: 1 }}>
                                    <FormGroup>
                                        <FormLabel>{language === "English" ? "Chinese Name" : "中 文 姓 名"}</FormLabel>
                                        <div className="d-flex align-items-center">
                                            <FormControl type="text" name="chinesename" maxLength="30"
                                                placeholder={language === "English" ? "ex: Wukong" : "ex：悟空"} value={chinesename}
                                                onChange={(event) => setChinesename(event.target.value)} disabled={!chinesenameModifyChecked} />
                                            <Form.Check>
                                                <Form.Check.Label>
                                                    <Form.Check.Input
                                                        label="ChinesenameModify"
                                                        type="checkbox"
                                                        checked={chinesenameModifyChecked}
                                                        onChange={handleChinesenameModifyChange}
                                                    ></Form.Check.Input>
                                                    <span className="form-check-sign"></span>
                                                    Modify
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </div>
                                    </FormGroup>
                                </Col>

                            </Row>
                            <Row>
                                <Col md={{ span: 10, offset: 1 }}>
                                    <FormGroup>
                                        <FormLabel>{language === "English" ? "Phone Number " : "電 話 號 碼"} <span className="text-danger">*</span></FormLabel>
                                        <div className="d-flex align-items-center">
                                            <FormControl type="number" name="phone" maxLength="30"
                                                placeholder="ex: 0433233343" value={phone} onChange={(event) => setPhone(event.target.value)} disabled={!phoneModifyChecked} />

                                            <Form.Check>
                                                <Form.Check.Label>
                                                    <Form.Check.Input
                                                        label="PhoneModify"
                                                        type="checkbox"
                                                        checked={phoneModifyChecked}
                                                        onChange={handlePhoneModifyChange}
                                                    ></Form.Check.Input>
                                                    <span className="form-check-sign"></span>
                                                    Modify
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </div>
                                        {phoneError && <small className="text-danger">{phoneError}</small>}
                                    </FormGroup>


                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 10, offset: 1 }}>
                                    <FormGroup>
                                        <FormLabel>{language === "English" ? "Email " : "電 子 郵 件"} <span className="text-danger">*</span></FormLabel>
                                        <div className="d-flex align-items-center">
                                            <FormControl type="email" name="email" maxLength="50"
                                                placeholder="ex: wukong@baolin.com" value={email} disabled={!emailModifyChecked}
                                                onChange={(event) => setEmail(event.target.value)} />

                                            <Form.Check>
                                                <Form.Check.Label>
                                                    <Form.Check.Input
                                                        label="EmailModify"
                                                        type="checkbox"
                                                        checked={emailModifyChecked}
                                                        onChange={handleEmailModifyChange}
                                                    ></Form.Check.Input>
                                                    <span className="form-check-sign"></span>
                                                    Modify
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </div>
                                        {emailError && <small className="text-danger">{emailError} </small>}
                                    </FormGroup>
                                </Col>

                            </Row>
                            {/* <Button type="submit" className="mt-3">Submit</Button> */}
                        </Form>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setEditGuestModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="submit" onClick={handleSubmit}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal >
        </>
    );

}

export default Edit3R5PModal;
